module.exports = __webpack_public_path__ + "ca219b329660af599521f87f6fc5cc44.png";